<script>
    import {createEventDispatcher, onMount} from "svelte";
    import { writable } from 'svelte/store';
    import { navigate } from "svelte-routing";

    let showLashes = false;
    let showBrows = false;
    let showLips = false;

    const dispatch = createEventDispatcher();
    let countSelectedServices;
    let durationMinutesCount = 0;
    const menu = [
        {
            title: "Lashes",
            submenu: [
                "Laminazione Ciglia + Tinta + Vitamin Lash Botox",
                "Laminazione Ciglia + Sopracciglia"
            ]
        },
        {
            title: "Brows",
            submenu: [
                "Laminazione sopracciglia + correzione forma+ tinta",
                "Laminazione sopracciglia + correzione forma senza colorazione",
                "Architettura Sopracciglia",
                "Architettura Sopracciglia + Tinta Bronsun",
                "Architettura Sopracciglia + Colorazione Henné",
                "POWDER BROWS (tatuaggio sopracciglia)",
                "Seconda seduta tatuaggio sopracciglia",
                "Ritocco annuale tatuaggio sopracciglia"
            ]
        },
        {
            title: "Lips",
            submenu: [
                'Tatuaggio Labbra "Juicy Lips"',
                'Seconda seduta "Juicy Lips"',
                'Ritocco annuale tatuaggio labbra'
            ]
        }
    ];

    let activeStatesStore = writable([]);
    export let selectedServices;

    function saveSelectedServices() {
        const selectedServices = menu.flatMap(({ submenu }, index) => {
            return submenu.filter((_, subIndex) => $activeStatesStore[index][subIndex]);
        });
        localStorage.setItem('selectedServices', JSON.stringify(selectedServices));
    }

    activeStatesStore.subscribe(value => {
        countSelectedServices = value.flat().filter(state => state).length;
        localStorage.setItem('selectedServices', JSON.stringify(value));
    });

    function confermareClicked() {
        saveSelectedServices();
    }

    function toggleActive(menuIndex, submenuIndex) {
        activeStatesStore.update(states => {
            const currentState = states[menuIndex][submenuIndex];
            states[menuIndex][submenuIndex] = !currentState;
            if (!currentState) {
                durationMinutesCount += 60;
                $selectedServices.add(menu[menuIndex].submenu[submenuIndex]);
            } else {
                durationMinutesCount -= 60;
                $selectedServices.delete(menu[menuIndex].submenu[submenuIndex]);
            }
            localStorage.setItem('durationMinutesCount', durationMinutesCount);
            return states;
        });
    }

    onMount(() => {
        $activeStatesStore = Array(menu.length).fill(false).map(() => Array().fill(false));
    })

    export let stage;
</script>


<style>
    .disabled {
        background-color: white !important;
        cursor: not-allowed !important;
        color:#8f8f8f !important;
        border: 1px solid #8f8f8f !important;
    }
    .s-main-container{
        display: flex;
        flex-direction: column;
        align-items: stretch;
    }
    .dat-div{
        display:flex;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
        padding: 20px;
        border-radius: 10px;
        user-select: none;
        background-color: white;
    }
    .icon{
        width: 35px;
        height: 35px;
    }
    .dat-services-div{
        display:flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;
        padding: 20px;
        border-radius: 10px;
        cursor:pointer;
        background-color: white;
        gap: 15px;
        user-select: none;
        box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    }
    .dat-services-div:hover{
        background-color: #f0f0f0;
    }
    .s-span{
        font-size:20px;
        margin-left:10px;
    }
    .default-button {

        background: #eca8ca;
        border: 1px solid #eca8ca;
        border-radius: 6px;
        box-shadow: rgba(0, 0, 0, 0.1) 1px 2px 4px;
        box-sizing: border-box;
        color: #FFFFFF;
        cursor: pointer;
        display: inline-block;
        font-size: 16px;
        font-weight: 600;
        line-height: 30px;
        min-height: 40px;
        outline: 0;
        padding: 14px 5px;
        text-align: center;
        text-rendering: geometricprecision;
        text-transform: none;
        user-select: none;
        -webkit-user-select: none;
        touch-action: manipulation;
        vertical-align: middle;
        width: 100%;
    }
    .default-button:hover,
    .default-button:active {
        background-color: white;
        background-position: 0 0;
        color: #eca8ca;
    }
    .s-confirm{
        position: fixed;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        background-color: white;
        padding: 20px;
        width: calc(50% - 40px);
        border-radius: 10px;
        height: 9%;
        box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    }
    .dat-div-back{
        display:flex;
        align-items: center;
        justify-content: center;
        margin-top: 10px;
        border-radius: 10px;
        user-select: none;
    }
    @media (max-width: 768px) {
        .s-confirm{
            width: 90%;
            padding: 5%;
        }
        .back-button{
            width: 50vw;
        }
        .dat-services-div:hover{
            background-color: white;
        }
    }
    .back-button {
        background: #ffffff;
        border: 1px solid #b2b2b2;
        border-radius: 6px;
        box-shadow: rgba(0, 0, 0, 0.1) 1px 2px 4px;
        box-sizing: border-box;
        color: #000000;
        cursor: pointer;
        display: inline-block;
        font-size: 16px;
        font-weight: 600;
        line-height: 30px;
        min-height: 40px;
        outline: 0;
        padding: 14px 5px;
        text-align: center;
        text-rendering: geometricprecision;
        text-transform: none;
        user-select: none;
        -webkit-user-select: none;
        touch-action: manipulation;
        vertical-align: middle;
        width: 200px;
    }
    .back-button:active {
        background-color: white;
        background-position: 0 0;
        color: black;
        opacity: .5;
    }
</style>

<div class="dat-div-back">
    <div class="back-button" on:click={() => navigate("/")}>
        <span>Indietro</span>
    </div>
</div>
<div class="dat-div">
    <img class="icon" src="./icons/clipboard.png" alt="services">
    <span style="margin-left:10px;font-size: 22px;">Seleziona i servizi</span>
</div>

<div class="s-confirm">
    <div>
        <span style="font-size: 18px;">Selezionati: {countSelectedServices}</span>
    </div>
    {#if countSelectedServices === 0}
        <div class="default-button disabled">
            <span style="font-size:20px;">Ulteriore</span>
        </div>
    {:else}
        <div class="default-button" on:click={() => { stage = "dateAndTime"; confermareClicked(); }}>
            <span style="font-size:20px;">Ulteriore</span>
        </div>
    {/if}
</div>

<div class="s-main-container">
    {#each menu as { title, submenu }, menuIndex}
        <div class="dat-services-div" style="padding: 25px 20px;" on:click={() => {
            if(menuIndex === 0) showLashes = !showLashes
            else if (menuIndex === 1) showBrows = !showBrows;
            else showLips = !showLips

        }}>
            <span class="s-span" style="font-weight: bold; font-size:24px;">{title}</span>
            <img class="icon" src="./icons/down-arrow.png" alt="add" style="transform: rotate({(menuIndex === 0 ? showLashes : showBrows) ? '180deg' : '0deg'})">
        </div>
        {#if (menuIndex === 0 && showLashes) || (menuIndex === 1 && showBrows) || (menuIndex === 2 && showLips)}
            {#each submenu as service, submenuIndex}
                <div class="dat-services-div {$activeStatesStore[menuIndex][submenuIndex] ? 'active' : ''}" on:click={() => toggleActive(menuIndex, submenuIndex)}>
                    <span class="s-span">{service}</span>
                    <img class="icon" src={"./icons/" + ($activeStatesStore[menuIndex][submenuIndex] ? "check.png" : "plus.png")} alt="upload">
                </div>
            {/each}
        {/if}
    {/each}
</div>